import React, { useState } from 'react'

const LiteYouTube = ({ videoId, title }) => {
  const [activated, setActivated] = useState(false)

  if (activated) {
    return (
      <figure className="video">
        <iframe
          title={title}
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          frameBorder="0"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </figure>
    )
  }

  return (
    <figure className="video">
      <button
        type="button"
        className="video__facade"
        onClick={() => setActivated(true)}
        aria-label={`Play ${title} video`}
      >
        <img
          className="video__thumb"
          src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
          alt={`${title} video thumbnail`}
          loading="lazy"
        />
        <span className="video__play" aria-hidden="true" />
      </button>
    </figure>
  )
}

export default LiteYouTube
